import { Col, Row, Segmented } from 'antd';
import { FC, memo, useState } from 'react';

import { RedirectsBulkByPages } from './RedirectsBulkByPages';
import { RedirectsBulkCreate } from './RedirectsBulkCreate';
import { RedirectsBulkManage } from './RedirectsBulkManage';

type BulkMode = 'create' | 'byPages' | 'manage';

interface Props {
  siteId: string;
}

export const RedirectsBulkContent: FC<Props> = memo(({ siteId }) => {
  const [mode, setMode] = useState<BulkMode>('create');

  return (
    <Row gutter={ [16, 16] }>
      <Col span={ 24 }>
        <Segmented
          block
          value={ mode }
          onChange={ (value) => setMode(value as BulkMode) }
          options={ [
            { label: 'Списком', value: 'create' },
            { label: 'Сторінки → шлях', value: 'byPages' },
            { label: 'Керування', value: 'manage' },
          ] }
          style={{ marginBottom: 16 }}
        />
      </Col>

      <Col span={ 24 }  >
        {mode === 'create' && (
          <RedirectsBulkCreate siteId={ siteId }/>
        )}

        { mode === 'byPages' && (
          <RedirectsBulkByPages siteId={ siteId }/>
        )}

        { mode === 'manage' && (
          <RedirectsBulkManage siteId={ siteId }/>
        )}
      </Col>
    </Row>
  );
});


